import React from 'react';
import { useSearchAdContext } from './SearchAdContext';
import { SearchAdLink } from './SearchAdLink';

export type SearchAdHeadingProps = {
    as?: string;
    children?: React.ReactNode;
    className?: string;
};

export function SearchAdHeading(props: SearchAdHeadingProps) {
    const { as = 'h2', children, className } = props;

    const { headingId, linkId } = useSearchAdContext();
    const headingClass = `h4 mb-0 ${className}`;

    return React.createElement(
        as,
        { className: headingClass, id: headingId },
        <SearchAdLink className="s-text! hover:no-underline" id={linkId}>
            {children}
        </SearchAdLink>,
    );
}
